export default {
  main: {
    title: 'การตรวจสอบเวอร์ชัน',
    language: 'ไทย',
    intro:
      'การตรวจสอบเวอร์ชันนั้น เป็นการเชื่อมโยงระหว่างค่าแฮช MD5 หรือ SHA256 ระหว่างเวอร์ชันต่างๆ โปรดตรวจสอบและดาวน์โหลด TokenPocket wallet ผ่านทางช่องทางอย่างเป็นทางการเพื่อป้องกันการถูกหลอกลวง สำหรับคำแนะนำเกี่ยวกับวิธีการรับค่าแฮช MD5 หรือ SHA256 ของเวอร์ชัน โปรด ',
    tutorial: 'อ่านคู่มือ >',
    system: 'ระบบปฏิบัติการ',
    android: 'Android',
    ios: 'iOS',
    version: 'เวอร์ชัน',
    allVersion: 'ทั้งหมด',
    appChannel: 'ช่องทางแอปพลิเคชัน',
    developer: 'นักพัฒนา',
    allChannel: 'ทั้งหมด',
    md5: 'MD5',
    sha256: 'SHA256',
    log: 'บันทึกเวอร์ชัน',
    check: 'รายละเอียด',
    versionLog: 'บันทึกเวอร์ชัน',
    confirm: 'ยืนยัน',
    aboutIOS: 'เกี่ยวกับเวอร์ชัน iOS',
    IOSDesc:
      'สำหรับเวอร์ชัน iOS เราให้บริการแอปเพียงแค่ใน App Store เท่านั้น แอปที่ดาวน์โหลดจาก App Store เท่านั้นที่จะติดตั้งได้อย่างถูกต้อง ดังนั้น กรุณายืนยัน App Store เป็นช่องทางดาวน์โหลดที่ถูกต้องสำหรับอุปกรณ์ Apple',
    IOSDesc_2:
      'นักพัฒนาของเวอร์ชันที่ดาวน์โหลดจาก App Store ก่อนวันที่ 8 ตุลาคม 2022 คือ TOKENPOCKET FOUNDATION LTD ซึ่งเป็นเวอร์ชันเริ่มต้นที่พัฒนาโดย TokenPocket นั่นเป็นกระเป๋าเงินที่ถูกต้องและสามารถใช้งานได้อย่างปกติ แต่การให้บริการการอัพเดตจะถูกระงับชั่วคราว',
    aboutAndroid: 'เกี่ยวกับเวอร์ชัน Android',
    androidDesc: 'ช่องทางดาวน์โหลด TokenPocket สำหรับ Android ปัจจุบันรวมถึงเว็บไซต์อย่างเป็นทางการ, ร้านค้า Google Play, ร้านค้าแอป Samsung, Huawei AppGallery, ร้านค้าแอป OPPO, และร้านค้าแอป Vivo. ในบางร้านค้าแอปไม่สามารถรับไฟล์ติดตั้ง APK ระหว่างขั้นตอนดาวน์โหลดได้เนื่องจากนั้นไม่สามารถทำการตรวจสอบ MD5 หรือ SHA256 ได้ ดังนั้นในการดาวน์โหลด กรุณาตรวจสอบข้อมูลผู้พัฒนาอย่างชัดเจนตามข้างล่าง!',
    IOSAppName: 'ชื่อแอปพลิเคชัน:',
    TPWallet: 'TP Wallet',
    AppIcon: 'ไอคอนแอปพลิเคชัน:',
    AppDeveloper: 'ผู้พัฒนา:',
    downloadLink: 'ลิงก์ดาวน์โหลด:',
    copied: 'คัดลอกแล้ว!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'ตามเรามา',
    desc1: 'พนักงาน TokenPocket จะไม่ส่งข้อความส่วนตัวถึงคุณ!',
    desc2:
      'คำเตือน! คุณกำลังเข้าสู่ชุมชน TokenPocket อาจมีใครบางคนแอบอ้างเราเพื่อส่งข้อความส่วนตัวถึงคุณ! โปรดทราบว่าทุกคนที่ส่งข้อความส่วนตัวอาจเป็นสแกมเมอร์! เราจะไม่ติดต่อคุณก่อน!',
    desc3: 'เข้าใจแล้ว ป้อน',
  },
  COMMON: {
    LAYOUT: {
      features: 'คุณสมบัติ',
      products: 'สินค้า',
      buyCryptoFooter: 'ซื้อ',
      mobileWallet: 'กระเป๋าเงินบนมือถือ',
      mobileWalletDesc: 'กระเป๋าเงินมือถือ Crypto & DeFi บนบล็อกเชน',
      hardwareWallet: 'กระเป๋าเงินฮาร์ดแวร์',
      hardwareWalletDesc: 'รับ KeyPal ของคุณ เพื่อปกป้องทรัพย์สินของคุณ',
      extensionWallet: 'กระเป๋าเงินสำหรับเบราว์เซอร์',
      extensionWalletDesc: 'กระเป๋าเงินที่ดีกว่าบนคอมพิวเตอร์ของคุณ',
      desktop: 'Desktop Wallet',
      fiveDegrees: '5Degrees',
      versionVerification: 'การตรวจสอบเวอร์ชัน',
      versionVerificationDesc: 'ตรวจสอบกระเป๋าเงินของคุณ',
      approvalDetector: 'ตรวจจับการอนุมัติ',
      approvalDetectorDesc: 'ดูและยกเลิกการอนุมัติโทเค็นของคุณที่ได้รับอนุมัติ',
      tokenSecurity: 'ความปลอดภัยของโทเค็น',
      tokenSecurityDesc: 'ตรวจสอบว่าโทเค็นปลอดภัยหรือไม่ด้วยที่อยู่สัญญาของมัน',
      keyGenerator: 'ตัวสร้างคีย์',
      keyGeneratorDesc: 'สร้างคีย์สาธารณะและส่วนตัวแบบสุ่มสำหรับเครือข่ายต่างๆ',
      tokenProfile: 'โปรไฟล์โทเค็น',
      tokenProfileDesc: 'เรียนรู้ข้อมูลทั้งหมดเกี่ยวกับโทเค็น',
      tokenClaim: 'การเรียกร้องโทเค็น',
      tokenClaimDesc: 'เรียกร้องแอร์ดรอปของคุณ',
      easyInscription: 'การจารึกอย่างง่าย',
      easyInscriptionDesc: 'เครื่องมือการจารึกที่ปลอดภัย',
      nostrAssetsBatchSender: 'NostrAssets BatchSender',
      nostrAssetsBatchSenderDesc: 'เครื่องมือการส่งแบบกลุ่มสำหรับ NostrAssets',
      BATCH_SENDER: 'BatchSender',
      BATCH_SENDER_DESC: 'ส่งโทเค็นไปยังผู้รับหลายรายพร้อมกัน',
  
      trade: 'การซื้อขาย',
      swap: 'แลกเปลี่ยน',
      swapDesc: 'ซื้อขายด้วยราคาที่ดีที่สุด',
      bridge: 'บริดจ์',
      bridgeDesc: 'ข้ามทรัพย์สินจากเชนหนึ่งไปยังอีกเชนหนึ่งอย่างราบรื่น',
      buyCrypto: 'ซื้อ',
      buyCryptoDesc: 'ซื้อสกุลเงินดิจิทัลด้วยบัตรเครดิตของคุณ',
      market: 'ตลาด',
      marketDesc: 'ข้อมูลเชิงลึกแบบเรียลไทม์เพื่อค้นหาโทเค็นที่น่าสนใจ',
  
      information: 'ข้อมูล',
      blockchainGuide: 'คู่มือบล็อคเชน',
      tronWallet: 'คู่มือ TRON',
      iostWallet: 'คู่มือ IOST',
      tpMan: 'ชาย TP',
  
      developers: 'นักพัฒนา',
      github: 'Github (TP-Lab)',
      devCenter: 'ศูนย์นักพัฒนา',
      developersDesc: 'เอกสารสำหรับนักพัฒนา TokenPocket',
      subToken: 'ส่งโทเค็น',
      subTokenDesc: 'ส่งโทเค็นของคุณ',
      subDApp: 'ส่ง DApp',
      subDAppDesc: 'ส่ง DApp ของคุณและแสดงหลังจากการตรวจสอบ',
      subNFT: 'ส่ง NFT',
      subNFTDesc: 'ส่ง NFT และศิลปะของคุณ',
      subChain: 'ส่งเชน',
      subChainDesc: 'ส่งบล็อกเชนของคุณ',
      bugBounty: 'Bug Bounty',
  
      tools: 'เครื่องมือ',
  
      build: 'สร้าง',
  
      learn: 'เรียนรู้',
  
      explorer: 'ตัวสำรวจ',
  
      company: 'บริษัท',
      about: 'กี่ยวกับ',
      careers: 'อาชีพ',
      pressKit: 'ชุดแบรนด์',
      swagShop: 'Swag Shop',
  
      support: 'การสนับสนุน',
      helpCenter: 'ศูนย์ช่วยเหลือ',
      helpCenterDesc: 'ทรัพยากรหลักของคุณสำหรับคำตอบและความช่วยเหลือ',
      contactUs: 'ติดต่อเรา',
      contactUsDesc: 'แชร์คำแนะนำของคุณและถามคำถามใด ๆ',
      forum: 'ฟอรั่ม',
      forumDesc: 'เพลิดเพลินไปกับการสนทนากับสมาชิกในชุมชน',
  
      legal: 'ถูกกฎหมาย',
      privacyPolicy: 'นโยบายความเป็นส่วนตัว',
      terms: 'ข้อกำหนดการใช้งาน',
  
      toHome: 'บ้าน',
      defiWallet: 'กระเป๋าเงินDeFi',
      ETHWallet: 'กระเป๋าเงินEthereum',
      ethWallet: 'กระเป๋าเงินETH',

      dappStore: 'ร้านค้า DApp'
    }
  }
};
